<!-- 업체 선택용 공통 팝업 -->
<template>

  <v-container fluid>

    <v-row dense no-gutters>
      <v-col cols="9">
          <v-text-field disabled dense outlined height="43" v-model="tempname" :label="$t('ceddialog_label')"></v-text-field>
      </v-col>
      <v-col cols="3">
          <v-btn class="ml-1 search_btn" elevation="0" outlined large @click="showpopup_com" >{{$t('common_select')}}</v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-dialog persistent overlay-color="#ffffffff" v-model="dialog_com" @keydown.esc="close_com" fullscreen>
        
        <v-card :height="DISPLAY_HEIGHT+100">
        <v-card-text>

        <v-container fluid>
          
          <v-row dense no-gutters>

            <v-col cols="4">
              <v-row align="center">
                <v-col cols="4">
                  <span class="dialog_title">{{$t('ceddialog_labe2')}}</span>
                </v-col>
                <v-col cols="2">
                    <v-btn class="search_btn" elevation="0" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
                </v-col>
              </v-row>
              <v-data-table
                :headers="headers"
                :items="items"
                v-model="select_com"
                :no-data-text="$t('design_msg11')"
                :no-results-text="$t('design_msg12')"
                hide-default-footer
                class="datatablestyle ml-10 mr-10"
                :items-per-page="9999"
                item-key="IDX"
                >
                <template v-slot:header.LAYOUT_NAME>
                  <label class="cheader_normal" >{{$t("ceddialog_col1")}}</label>
                </template>
                <template v-slot:header.detail>
                  <label class="cheader_normal" >{{$t("ceddialog_col2")}}</label>
                </template>
                <template v-slot:item.LAYOUT_NAME="{ item }">
                  <a @click="loaddetail_com(item)">{{item.LAYOUT_NAME}}</a>
                </template>
              </v-data-table>

            </v-col>

            <v-col cols="8">
              <v-col cols="12" md="12" sm="12" xs="12" class="d-flex justify-center">
                <v-btn class="dialog_cancel_btn mr-2" large rounded @click="close_com">{{$t("common_close")}}</v-btn>
                <v-btn class="dialog_btn" large rounded @click="save_com">{{$t('common_select')}}</v-btn>
              </v-col>
              <v-row justify="center">
                <!-- 미리보기 영역 -->
                <div id="edit_div_com" :style="'width:'+DISPLAY_WIDTH+'px;height:'+DISPLAY_HEIGHT+'px;backgroundColor:#808080;overflow:hidden;position:absolute;border:solid 2px red;'">
                </div>
              </v-row>
            </v-col>

          </v-row>

        </v-container>
      
      </v-card-text>
      </v-card>
      </v-dialog>     

    </v-row>

  </v-container>
  
</template>

<script>
// eslint-disable-next-line no-unused-vars
import DRBackground from '../dragndrop/DRBackground.js'
import DRComponent from '../dragndrop/DRComponent.js'
import DRModel from '../dragndrop/DRModel.js'

    export default {

        //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
        props:{
            tempname:String,
            comidx: Number,
            eventidx: Number
        },

        data: ()=> ({
            
            comdrback: null,

            dialog_com : false,
            load_flag : false,

            headers: [
              {text: '템플릿명', align: 'center', sortable: false, value: 'LAYOUT_NAME'},
              {text: '디자인', align: 'center', sortable: false, value: 'detail'},
            ],
            search_type : 'LAYOUT_NAME',   
            search_keyword : '',
            
            items: [],
            PARENT_ITEM: {},

            itemList_com: [],
            select_com:[],
            
            MATCHTYPELIST: [],
        
            DISPLAY_WIDTH:384,
            DISPLAY_HEIGHT:463,

        }),


        updated(){
          
          if(this.dialog_com){
            if(!this.load_flag && this.items.length == 0 && this.search_keyword.length == 0){
              this.load_flag = true;
              this.loadpage();
            }
          }else{
            this.load_flag = false;
          }

        },

        methods: {

            //검색
            search_run(){
              this.loadpage();
            },

            loadpage(){

                this.$http.post(this.$host+'/api/EmailDesignList',
                  {
                      ADMIN_IDX : this.$session.get("ADMIN_IDX")
                    , COM_IDX:    this.comidx
                    , EVENT_IDX : this.eventidx
                  },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
                .then((result)=>{
                  this.load_flag = true;
                  if(result.data.resultCode == 0){

                    //토큰 저장
                    if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                      this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                    }
                    if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                      this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                    }

                    const list = result.data.resultData;
                    this.items.splice(0, this.items.length);   //데이터 초기화
                    list.forEach(element => {
                        this.items.push(element); 
                    });


                  }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$alert(this.$t("common_tokener"));
                    this.$session.clear("ADMIN_IDX");
                    this.$session.clear("COM_IDX");
                    this.$session.clear("ACNT_IDX");
                    this.$session.clear("GRADE");
                    this.$session.clear("COM_NAME");
                    this.$session.clear("ACCESSTOKEN");
                    this.$session.clear("REFLASHTOKEN");
                    this.$router.push('Login');   //로그인 페이지로 이동

                  }else{
                    //BG초기화
                    this.drback.clearBackground();
                  }
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error)=>{
                });

            },

            //DRBackground가 호출함. 무조건 있어야함.
            colorupdate(){

            },

            loaddetail_com(item){
              this.PARENT_ITEM = item;
              this.$http.post(this.$host+'/api/EmailDesignDetail',
                {
                    ADMIN_IDX : this.PARENT_ITEM.ADMIN_IDX
                  , COM_IDX : this.PARENT_ITEM.COM_IDX
                  , EVENT_IDX : this.PARENT_ITEM.EVENT_IDX
                  , EMAIL_IDX : this.PARENT_ITEM.EMAIL_IDX
                },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
              .then((result)=>{
                
                if(result.data.resultCode == 0){

                  //토큰 저장
                  if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                    this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                  }
                  if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                    this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                  }

                  //초기화
                  var tempobj   = JSON.parse(JSON.stringify(result.data.resultData)); //파싱
                  var component = tempobj[0].COMPONENT;
                  this.DISPLAY_WIDTH = tempobj[0].COMPONENT_WIDTH;
                  this.DISPLAY_HEIGHT = tempobj[0].COMPONENT_HEIGHT;

                    //BG초기화
                    var edit_div = document.getElementById("edit_div_com");
                    while ( edit_div.hasChildNodes() ) {
                      edit_div.removeChild( edit_div.firstChild ); 
                    }

                    const bg = new DRModel();
                    bg.LAYOUT_WIDTH   = this.DISPLAY_WIDTH;
                    bg.LAYOUT_HEIGHT  = this.DISPLAY_HEIGHT;
                    bg.LAYOUT_POSX    = 0;
                    bg.LAYOUT_POSY    = 0;
                    bg.ISBG           = 1;  //bg
                    bg.COMPONENT_TYPE = 0; 
                    bg.BGTYPE = 0;
                    bg.BGCOLOR = "FFFFFFFF";
                    this.comdrback  = new DRBackground(bg, [], this, true);
                    edit_div.appendChild(this.comdrback.back_div);

                    this.comdrback.clearBackground();
                    this.createComponent(this.comdrback,  component.data);

                }else if(result.data.resultCode == 2){
                  //로그인 필요
                  this.$alert(this.$t("common_tokener"));
                  this.$session.clear("ADMIN_IDX");
                  this.$session.clear("COM_IDX");
                  this.$session.clear("ACNT_IDX");
                  this.$session.clear("GRADE");
                  this.$session.clear("COM_NAME");
                  this.$session.clear("ACCESSTOKEN");
                  this.$session.clear("REFLASHTOKEN");
                  this.$router.push('Login');   //로그인 페이지로 이동

                }else{
                  //BG초기화
                  this.drback.clearBackground();
                }
                
              })
              // eslint-disable-next-line no-unused-vars
              .catch((error)=>{
                  //BG초기화
                  //console.log("error : " + error);
              });


            },

            //다이얼로그 닫기
            close_com () {
                this.dialog_com = false
                this.select_com = [];
                this.items.splice(0, this.items.length);   //데이터 초기화
                this.search_keyword = '';
                //BG초기화
                const edit_div = document.getElementById("edit_div_com");
                while ( edit_div.hasChildNodes() ) {
                  edit_div.removeChild( edit_div.firstChild ); 
                }
            },

            //추가 저장
            save_com(){

              if(this.PARENT_ITEM.EMAIL_IDX == null || this.PARENT_ITEM.EMAIL_IDX == undefined){
                this.$alert(this.$t('ceddialog_labe3'));
                return;
              }

              this.$emit('callback', this.PARENT_ITEM)
              //콜백 호출 후 닫아야함.
              this.dialog_com = false
              this.select_com = [];
              this.items.splice(0, this.items.length);   //데이터 초기화
              this.search_keyword = '';
              //BG초기화
              const edit_div = document.getElementById("edit_div_com");
              while ( edit_div.hasChildNodes() ) {
                edit_div.removeChild( edit_div.firstChild ); 
              }

            },      

            showpopup_com(){
                this.dialog_com = true;
                this.load_flag = false;
            },

            createComponent(bg, list){

              //컴포넌트 생성
              list.forEach(element => {
                
                const model = new DRModel();
                model.ADMIN_IDX     = element.ADMIN_IDX;
                model.EVENT_IDX     = element.EVENT_IDX;
                model.STEP_IDX      = element.STEP_IDX;
                model.IMG           = element.IMG;
                model.LOCALIMG      = null;
                model.ISBG          = element.ISBG;
                model.BGTYPE        = element.BGTYPE;
                model.BGCOLOR       = element.BGCOLOR;
                model.TEXTCOLOR     = element.TEXTCOLOR;
                model.TEXTSIZE      = element.TEXTSIZE;
                model.TEXTFONT      = element.TEXTFONT;
                model.TEXTVALUE     = element.TEXTVALUE;
                model.TEXTALIGN     = element.TEXTALIGN;
                model.TEXTMATCH     = element.TEXTMATCH;
                model.LAYOUT_WIDTH  = parseInt(element.LAYOUT_WIDTH);
                model.LAYOUT_HEIGHT = parseInt(element.LAYOUT_HEIGHT);
                model.LAYOUT_POSX   = parseInt(element.LAYOUT_POSX);
                model.LAYOUT_POSY   = parseInt(element.LAYOUT_POSY);
                model.ROTATE        = element.ROTATE || 0;
                
                model.TEMP_POSX   = model.LAYOUT_POSX;
                model.TEMP_POSY   = model.LAYOUT_POSY;
                model.TEMP_WIDTH  = model.LAYOUT_WIDTH;
                model.TEMP_HEIGHT = model.LAYOUT_HEIGHT;

                model.ZINDEX         = element.ZINDEX;
                model.COMPONENT_TYPE = element.COMPONENT_TYPE;

                //새롭게 타입이 추가됨. 기존에 만들어진 디자인의 경우 호환을 위해 강제로 1처리 = TEXT
                if(element.ISBG == undefined || element.ISBG == null){
                  if(element.LAYOUT_WIDTH == 384 && element.LAYOUT_POSX == 0 && element.LAYOUT_POSY == 0){
                    model.ISBG = 1; //bg
                    //bg는 this.drback에 직접 처리
                    bg.updateBackground(model);
                    return;
                  }else{
                    model.ISBG = 0;
                    if(element.COMPONENT_TYPE == undefined || element.COMPONENT_TYPE == null){
                      if(element.TEXTVALUE != null && element.TEXTVALUE.length > 0){
                        model.COMPONENT_TYPE = 1; //text
                      }else{
                        model.COMPONENT_TYPE = 0; //image
                      }
                    }
                  } 
                }

                

                if(element.ISBG == 1){
                    bg.updateBackground(model);
                    return;
                }

                //컴포넌트 객체 생성.
                const component = new DRComponent(model, this.MATCHTYPELIST, false);
                bg.addComponent(component);

              });

            },

        }

    }
</script>

<style scoped>


</style>